<template>
  <div id="wrapper" class="wrapper">
    <van-list
      v-model:loading="loading"
      class="list"
      :finished="finished"
      loading-text="加载中"
    >
      <div class="item-list">
        <div v-for="(item, index) in contents" :key="index" class="item">
          <div class="user_msg">
            <van-image
              class="user_msg_icon"
              fit="cover"
              round
              :src="item.head"
              width="36"
              height="36"
              @click="toHomePage(item)"
            />
            <div class="user_msg_right">
              <div class="user_msg_title">
                <div class="line-1 user_msg_title_name">
                  {{ item.nick_name }}
                </div>
              </div>
              <div class="user_msg_date">
                <span class="fen">{{ item.total_score }}</span> 分
              </div>
            </div>
          </div>
          <div class="content line-2">
            <van-text-ellipsis
              rows="2"
              :content="item.content"
              expand-text="展开"
              collapse-text="收起"
            />
          </div>
          <div class="info_title_box">
            <div class="info_title_tip" @click="toDetail(item)">原文</div>
            <div class="info_title line-1" @click="toDetail(item)">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <van-cell v-if="contents.length == 0">
        <van-empty description="暂无内容" />
      </van-cell>
    </van-list>
  </div>
  <!-- </van-pull-refresh> -->
</template>

<script>
import {
  Image as VanImage,
  Empty as VanEmpty,
  Cell as VanCell,
  List as VanList,
  TextEllipsis as VanTextEllipsis,
} from "vant";
import Api from "../api";
import { watchEffect, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
export default {
  components: {
    VanImage,
    VanEmpty,
    VanCell,
    VanList,
    VanTextEllipsis,
  },
  // eslint-disable-next-line vue/require-default-prop
  props: { current_journal: {} },
  emits: ["setText"],
  setup(props, context) {
    const router = useRouter();
    const contents = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    //是否发送请求
    const sendApi = ref(false);
    const getCommentRanking = (text) => {
      loading.value = true;
      Api.getItemCommentRanking({ date: text }).then((res) => {
        console.log("返回", res.data);
        loading.value = false;
        const curret_text = sessionStorage.getItem("text");
        if (res.data.length == 0 && !curret_text && !sendApi.value) {
          sendApi.value = true;
          context.emit("setText", subtractOneMonth(text));
          sessionStorage.setItem("text", subtractOneMonth(text).join("-"));
          getCommentRanking(subtractOneMonth(text).join("-"));
          finished.value = true;
          return;
        } else {
          if (curret_text && sendApi.value) {
            sessionStorage.removeItem("text");
          }
          contents.value = res.data;
          finished.value = true;
        }
      });
    };

    //获取上一个月
    const subtractOneMonth = (dateString) => {
      const date = new Date(dateString);
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return [year, month];
    };
    const toDetail = (item) => {
      if (item.url) {
        const userAgentString = navigator.userAgent.toLowerCase();
        if (userAgentString.indexOf("zsrbapp") >= 0) {
          window.ZsrbApp.call("viewInfo", {
            type: "",
            id: item.info_id,
            title: item.title,
            img: "",
            summary: "",
            url: item.url,
            isComment: item.is_comment || 0,
            commentCount: 0,
          });
        } else if (userAgentString.indexOf("micromessenger") >= 0) {
          window.open(item.url, "_blank");
        }
      }
    };

    watchEffect(() => {
      // 当parentData变化时，会执行这里的代码
      console.log("parentData changed:", props.current_journal);
      // 可以在这里进行数据请求等操作
      if (props.current_journal.text) {
        getCommentRanking(props.current_journal.text);
      }
    });

    const toHomePage = (item) => {
      const userAgentString = navigator.userAgent.toLowerCase();
      if (userAgentString.indexOf("zsrbapp") >= 0) {
        window.ZsrbApp.call("viewInfo", {
          type: "",
          id: "",
          title: "",
          img: "",
          summary: "",
          url: `https://zsrbapp.zsnews.cn/mobile/newsDetail/#/homePage/${item.user_id}`,
          isComment: 0,
          commentCount: 0,
        });
      } else if (userAgentString.indexOf("micromessenger") >= 0) {
        router.push({ path: "/homePage/" + item.user_id });
      }
    };

    onMounted(() => {
      // getCommentRanking();
    });

    return {
      contents,
      loading,
      finished,
      toDetail,
      toHomePage,
    };
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 0 16px;
  position: relative;
  z-index: 1;
  background: #fff;
  border-radius: 10px;
}
.line-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 3;
  -moz-box-orient: vertical;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}

.list {
  padding: 0 16px 10px;

  .item-list {
    .current_journal_title {
      display: flex;
      align-items: center;
      color: #ff4e4e;
      font-size: 18px;
      font-weight: 700;

      &_icon {
        margin-right: 8px;
      }
    }

    .item {
      padding: 14px 0 12px;
      border-bottom: 1px solid #ececec;

      .user_msg {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &_icon {
          margin-right: 10px;
          min-width: 36px;
          min-height: 36px;
        }
        &_right {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
        &_title {
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #6d6d6d;
          &_name {
            max-width: 180px;
          }
          &_red {
            color: #ffe49b;
            font-size: 10px;
            margin-left: 9px;
            padding: 3px 6px;
            background-color: #ff444c;
            box-shadow: 0pt 1px 3px 0pt rgba(255, 68, 76, 0.37);
            border: 1px solid #ffefc4;
            border-radius: 19px;
          }
        }

        &_date {
          font-size: 16px;
          color: #ff6823;
          display: flex;
          align-items: center;
          .fen {
            margin-right: 2px;
            font-size: 23px;
            font-weight: 700;
          }
        }
      }

      .content {
        margin-bottom: 10px;
        font-size: 16px;
        color: #2a2a2a;
        :deep(.van-text-ellipsis__action) {
          font-size: 14px;
        }
      }
    }

    .item:last-child {
      border-bottom: none;
    }
  }
}

.info_title_box {
  display: flex;
  align-items: center;
  background: rgba(227, 233, 255, 0.3);
  padding: 12px 10px;
  border-radius: 6px;
  .info_title {
    font-size: 14px;
    color: #848484;
    text-align: left;
  }

  .info_title_tip {
    white-space: nowrap;
    color: #ff5c5c;
    background: #ffe5e3;
    font-size: 12px;
    width: 35px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    margin-right: 6px;
  }

  .to_link {
    font-size: 14px;
    color: #1d89ff;
  }
}

.line-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
